import {createSlice, PayloadAction} from "@reduxjs/toolkit";

const initialMultiGymsState: IInitialMultiGymsState = {
    activeGym: {} as IMultiGymInfo,
    franchiseGymsList: [],
    masterGymServerPath: ""
}

export interface IMultiGymInfo {
    city: string;
    country: string;
    endpoint: string;
    id: number;
    name: string;
    postcode: string;
    street: string;
    streetNumber: string;
    isUserRegistered?: boolean;
    isMasterGym: boolean;
}

interface IInitialMultiGymsState {
    activeGym: IMultiGymInfo;
    franchiseGymsList: IMultiGymInfo[];
    masterGymServerPath: string;
}

export const multiGymsSlice = createSlice({
    name: "multiGyms",
    initialState: initialMultiGymsState,
    reducers: {
        setActiveGym(state, action: PayloadAction<IMultiGymInfo>) {
            state.activeGym = action.payload;
        },
        setFranchiseGymsList(state, action: PayloadAction<IMultiGymInfo[]>) {
            state.franchiseGymsList = action.payload;
            state.masterGymServerPath = action.payload.find(el => el.isMasterGym)?.endpoint || "";
        }
    }
})

export const {setActiveGym, setFranchiseGymsList} = multiGymsSlice.actions;

export default multiGymsSlice.reducer;